var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v("Dashboard")]),_c('v-card-text',[_vm._v(" ")]),_c('v-card-text')],1)}
var staticRenderFns = []

export { render, staticRenderFns }